module.exports = __webpack_public_path__ + "static/media/RM007_COVER1_FORPRINT_compressed-16.d49865a2.jpg";